import { AboutModule } from "./AboutModule";
import { GridLayerModule } from "./layers/GridLayer";
import { ConstellationLayerModule } from "./layers/ConstellationLayer";
import { HipparcosCatalogLayerModule } from './layers/HipparcosCatalogLayer'
import { ToolModule } from "./ToolModule";
import { PrettyPictureLayerModule } from "./layers/PrettyPictureLayer";
import { BookmarkModule } from "./BookMarkModule";
import { BackgroundModule } from "./BackgroundModule"
import { SspDataModule } from "./SspDataModule";
import { HipsModule } from "./HipsModule"
import { CoordIndicatorModule } from "./CoordIndicatorModule";
import { CatalogOverplotModule } from "./CatalogOverplotModule";
import { CasModule } from "./ssp_database/CasModule";
import { ImageCutoutModule } from "./ssp_database/ImageCutoutModule";
import { ExternalServicesModule } from "./ExternalServicesModule";
import { ObjectProfileModule } from "./ssp_database/ObjectProfileModule";
import { TractModule } from "./TractModule";
import { FitsImageModule } from "./FitsImageModule";
import { IframeModule } from "./IframeModule";
import { env } from '@/env';
import { RulerModule } from './RulerModule';
import { ExternalTileDataModule } from "./ExternalTileDataModule";
import { queryParams } from '@/utils/query_params';
import { JupyterModule } from './JupyterModule';


export const moduleRegistry = {
  about: AboutModule,
  gridLayer: GridLayerModule,
  rulerModule: RulerModule,
  constellationLayer: ConstellationLayerModule,
  hipparcosCatalogLayer: HipparcosCatalogLayerModule,
  tool: ToolModule,
  bookmark: BookmarkModule,
  sspData: SspDataModule,
  background: BackgroundModule,
  hips: HipsModule,
  coordIndicator: CoordIndicatorModule,
  fitsImage: FitsImageModule,
  catalogOverPlot: CatalogOverplotModule,
  prettyPicture: PrettyPictureLayerModule,
  externalService: ExternalServicesModule,
  objectProfile: ObjectProfileModule,
  tract: TractModule,
  externalTileData: ExternalTileDataModule,
  ...(env.databaseService ?
    {
      cas: CasModule,
      imageCutout: ImageCutoutModule,
    } :
    {}
  ),
  ...(env.mustLogin ?
    {} :
    { iframeModule: IframeModule }
  ),
  ...(process.env.NODE_ENV === 'development' ?
    { iframeModule: IframeModule } :
    {}
  ),
  ...(queryParams.jupyter ? {
    jupyter: JupyterModule
  } : {}),
}


export type ModuleRegistry = typeof moduleRegistry
export type ModuleNames = keyof ModuleRegistry
export type ModuleFrameStore = { [P in ModuleNames]: ReturnType<InstanceType<ModuleRegistry[P]>["frameStore"]> }